import React, { useState, useEffect } from "react";
import Product from "../Sales/Product";
import { Grid } from "@material-ui/core";
import MethodGet from "../../Config/Services";
import Swal from "sweetalert2";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  image: {
    width: 250,
    height: 300,
    display: "block",
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "80%",
    maxHeight: "100%",
  },
}));

const ProductInfo = ({
  productoID,
  ventas,
  guardarVenta,
  guardarProductoID,
  clienteID,
  box,
}) => {
  const [cargandoAnimacion, guardarAnimacion] = useState(false);
  const [producto, guardarProducto] = useState({});
  const [cantidad, guardarCantidad] = useState(1); // Cambia esto desde 0 a 1
  const [errorCantidad, guardarError] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    guardarAnimacion(true);
    setTimeout(() => {
      guardarAnimacion(false);
    }, 3000);
  }, []);
  //console.log(productoID,'info')
  let url = `/products/${productoID}`;
  useEffect(() => {
    if (productoID) {
      MethodGet(url)
        .then((response) => {
          guardarProducto(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [productoID]);
  const AgregarProductosState = () => {
    if (cantidad > producto.quantity) {
      guardarError(true);
      return;
    } else if (clienteID == undefined) {
      Swal.fire({
        title: "Antes de continuar",
        text: "Selecciona un cliente",
        icon: "error",
        timer: 2500,
        showConfirmButton: false,
      });
      return;
    }
    guardarError(false);
    let productoResultado = producto;
    //generar una llave unica para cada producto
    productoResultado.product_id = producto.id;
    //generar cantidad productos por adquirir
    productoResultado.cantidad = Number(cantidad);
    //generar precio final por producto
    productoResultado.final_price = Number(cantidad) * Number(producto.price);
    //guardarlo en el state
    guardarVenta([productoResultado, ...ventas]);
    //recetear el state del producto
    guardarProductoID("");
    guardarProducto({});
    guardarCantidad(1);
  };

  return (
    <Grid container>
      {box == 1 ? (
        <Grid item xs={12} md={12} xl={12} className={classes.image}></Grid>
      ) : (
        <>
          <Grid item xs={12} sm={12} style={{marginTop:"-20px"}}>
            <Product
              producto={producto}
              AgregarProductosState={AgregarProductosState}
              guardarCantidad={guardarCantidad}
              errorCantidad={errorCantidad}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ProductInfo;
